// extracted by css-extract-rspack-plugin
export default {"cls1":"MinimalStickyFooter-cls1_Ib_","cls2":"MinimalStickyFooter-cls2_5bH MinimalStickyFooter-cls1_Ib_"};